import { useParams } from 'react-router-dom';

import { useProject } from '@/hooks/use-projects';

export function ProjectInventoryPage() {
  const { projectKey } = useParams<{ projectKey: string }>();
  const key = projectKey ?? '';

  const { data: project, isLoading: projectLoading } = useProject(key);

  return (
    <main id="main-content" className="mx-auto max-w-4xl">
      <header className="mb-6">
        <h1 className="text-2xl font-bold text-content">Inventory</h1>
        <p className="mt-1 text-sm text-content-secondary">
          Ansible inventory for this project
        </p>
      </header>

      {projectLoading && (
        <div aria-busy="true" className="animate-pulse space-y-3">
          <div className="h-40 rounded-lg bg-gray-200 dark:bg-gray-700" />
        </div>
      )}

      {!projectLoading && project?.inventory && (
        <pre className="rounded-lg border border-border bg-surface-raised p-4 text-xs text-content overflow-x-auto whitespace-pre-wrap">
          {project.inventory}
        </pre>
      )}

      {!projectLoading && !project?.inventory && (
        <div className="rounded-lg border border-border p-6 text-center">
          <p className="text-sm text-content-secondary">
            No inventory supplied. Does this project deploy using Ansible?
          </p>
        </div>
      )}
    </main>
  );
}
